export default __webpack_public_path__ + "static/media/cp_geo_cn.ddc8c3f6.svg";